import { render } from "./StoriesMenuSlider.vue?vue&type=template&id=de24cf0e&scoped=true"
import script from "./StoriesMenuSlider.vue?vue&type=script&lang=js"
export * from "./StoriesMenuSlider.vue?vue&type=script&lang=js"

import "./StoriesMenuSlider.vue?vue&type=style&index=0&id=de24cf0e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de24cf0e"]])

export default __exports__